/** Local project flags live under public/images/countries/*.svg */
const LOCAL_FLAG_BASE_PATH = '/images/countries';

function isDataOrBlobUrl(value) {
    return /^(?:data|blob):/i.test(value);
}

function flagFileName(value, code) {
    const raw = String(value || '').trim();
    if (raw) {
        const clean = raw.split(/[?#]/, 1)[0];
        const parts = clean.split('/').filter(Boolean);
        const fileName = parts[parts.length - 1] || '';
        if (fileName) {
            return fileName.toLowerCase();
        }
    }

    const normalizedCode = String(code || '').trim().toLowerCase();
    return normalizedCode ? `${normalizedCode}.svg` : '';
}

/**
 * Current site origin for absolute asset URLs:
 * local → https://vignetteslovenia.local
 * live  → https://vignetteslovenia.si
 */
function projectOrigin() {
    if (typeof window !== 'undefined' && window.location?.origin) {
        return String(window.location.origin).replace(/\/$/, '');
    }
    return '';
}

function toAbsoluteProjectUrl(path) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const origin = projectOrigin();
    return origin ? `${origin}${normalizedPath}` : normalizedPath;
}

function buildLocalUrl(fileName) {
    return toAbsoluteProjectUrl(
        `${LOCAL_FLAG_BASE_PATH}/${encodeURIComponent(String(fileName).toLowerCase())}`
    );
}

/**
 * Force the last path segment (flag file name) to lowercase while keeping the rest of the URL.
 * Example: /img/foo/GB.svg → /img/foo/gb.svg
 */
function lowercaseFilenameInUrl(url) {
    const raw = String(url || '');
    return raw.replace(
        /([^/\\]+)(\.[^/\\.?]+)(\?.*)?$/,
        (_, name, ext, query = '') => name.toLowerCase() + ext.toLowerCase() + query
    );
}

/**
 * Normalize any API / CDN / bare flag value to this project's absolute local URL:
 * https://{current-host}/images/countries/{code}.svg
 */
export function resolveFlagUrl(value, code = '') {
    const raw = String(value || '').trim();
    if (!raw && !code) return '';

    // Non-flag project icons — leave path intact, only lowercase filename.
    if (raw.startsWith('/img/')) {
        return toAbsoluteProjectUrl(lowercaseFilenameInUrl(raw));
    }

    if (isDataOrBlobUrl(raw)) {
        return raw;
    }

    const fileName = flagFileName(raw, code);
    return fileName ? buildLocalUrl(fileName) : '';
}

export function normalizeFlagEntity(entity) {
    if (!entity || typeof entity !== 'object') return entity;
    return {
        ...entity,
        flag: resolveFlagUrl(entity.flag, entity.code)
    };
}
